import { render, staticRenderFns } from "./dashboard-notifications.vue?vue&type=template&id=3f9ceaec&scoped=true"
import script from "./dashboard-notifications.vue?vue&type=script&lang=js"
export * from "./dashboard-notifications.vue?vue&type=script&lang=js"
import style0 from "./dashboard-notifications.vue?vue&type=style&index=0&id=3f9ceaec&prod&scoped=true&lang=css"
import style1 from "./dashboard-notifications.vue?vue&type=style&index=1&id=3f9ceaec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9ceaec",
  null
  
)

export default component.exports